// =====================================================================
// UserAvatar (Quadros PRO / S60) — bolinha do membro estilo Trello:
// mostra a FOTO de perfil do usuário do CRM; cai nas INICIAIS se não houver
// foto (ou se a imagem falhar ao carregar). Foto servida em
//   ${backendUrl}/public/company<id>/user/<profileImage>  (igual ao avatar do topo).
// =====================================================================
import React, { useState } from "react";
import api from "../../services/api";

const COLORS = ["#1565c0", "#2e7d32", "#6a1b9a", "#ad1457", "#00838f", "#4e342e", "#ef6c00"];
const initials = (name) =>
  String(name || "").trim().split(/\s+/).slice(0, 2).map((s) => s[0] || "").join("").toUpperCase() || "?";
const colorFor = (id) => COLORS[Math.abs(Number(id) || 0) % COLORS.length];

const backendUrl = process.env.REACT_APP_BACKEND_URL || (api.defaults && api.defaults.baseURL) || "";

const UserAvatar = ({ user, companyId, size = 22, title, style }) => {
  const [err, setErr] = useState(false);
  const tt = title || (user && user.name) || "";
  const base = {
    width: size, height: size, borderRadius: "50%", flex: "0 0 auto",
    display: "inline-flex", alignItems: "center", justifyContent: "center",
    boxShadow: "0 0 0 1.5px rgba(255,255,255,.7)", ...style
  };

  const imgSrc = user && user.profileImage && companyId && !err
    ? `${backendUrl}/public/company${companyId}/user/${user.profileImage}`
    : "";

  if (imgSrc) {
    return <img src={imgSrc} alt={tt} title={tt} onError={() => setErr(true)} style={{ ...base, objectFit: "cover" }} />;
  }
  return (
    <span title={tt} style={{ ...base, background: colorFor(user && user.id), color: "#fff", fontSize: Math.round(size * 0.42), fontWeight: 700 }}>
      {initials(user && user.name)}
    </span>
  );
};

export default UserAvatar;
